define("calendar/components/calendar/multiple-bttp-upgrade-banner", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.shouldShow}}
    <div
      class="cCA--multipleBttp__upgradeBanner qa-multiple-bttp-upgrade-banner"
      data-test-id="multiple-bttp-upgrade-banner"
    >
      <span class="u--flex__grow--1" />
      <Shared::Ui::Button
        @class="u--p__tb cCA--multipleBttp__button qa-multiple-bttp-upgrade-banner__button"
        @onClick={{this.upgrade}}
        @variant="unstyled"
        data-test-id="multiple-bttp-upgrade-banner__button"
      >
        {{svg-jar "lock" class="o--icon--sm u--m__r__xs"}}
        {{t "bttp.calendar_upgrade_multiple_banner"}}
      </Shared::Ui::Button>
      <span class="u--flex__grow--1" />
      <Shared::Ui::Button @additional="rounded" @onClick={{this.closeBanner}} @size="small" @variant="unstyled">
        {{svg-jar "close" class="o--icon o--icon--black"}}
      </Shared::Ui::Button>
    </div>
  {{/if}}
  */
  {
    "id": "I+VQcPJ1",
    "block": "[[[41,[30,0,[\"shouldShow\"]],[[[1,\"  \"],[10,0],[14,0,\"cCA--multipleBttp__upgradeBanner qa-multiple-bttp-upgrade-banner\"],[14,\"data-test-id\",\"multiple-bttp-upgrade-banner\"],[12],[1,\"\\n    \"],[10,1],[14,0,\"u--flex__grow--1\"],[12],[13],[1,\"\\n    \"],[8,[39,1],[[24,\"data-test-id\",\"multiple-bttp-upgrade-banner__button\"]],[[\"@class\",\"@onClick\",\"@variant\"],[\"u--p__tb cCA--multipleBttp__button qa-multiple-bttp-upgrade-banner__button\",[30,0,[\"upgrade\"]],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,2],[\"lock\"],[[\"class\"],[\"o--icon--sm u--m__r__xs\"]]]],[1,\"\\n      \"],[1,[28,[35,3],[\"bttp.calendar_upgrade_multiple_banner\"],null]],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[10,1],[14,0,\"u--flex__grow--1\"],[12],[13],[1,\"\\n    \"],[8,[39,1],null,[[\"@additional\",\"@onClick\",\"@size\",\"@variant\"],[\"rounded\",[30,0,[\"closeBanner\"]],\"small\",\"unstyled\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,2],[\"close\"],[[\"class\"],[\"o--icon o--icon--black\"]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[],false,[\"if\",\"shared/ui/button\",\"svg-jar\",\"t\"]]",
    "moduleName": "calendar/components/calendar/multiple-bttp-upgrade-banner.hbs",
    "isStrictMode": false
  });
  let MultipleBttpUpgradeBannerComponent = _exports.default = (_dec = (0, _service.inject)('calendar/bttp'), (_class = class MultipleBttpUpgradeBannerComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "bttp", _descriptor2, this);
      _initializerDefineProperty(this, "segment", _descriptor3, this);
      _initializerDefineProperty(this, "seamlessCheckoutManager", _descriptor4, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor5, this);
      _initializerDefineProperty(this, "hasBeenClosed", _descriptor6, this);
    }
    get shouldShow() {
      return !this.auth.currentAccount.canMultipleBttp && this.bttp.multipleBttpTrialExpired && !this.hasBeenClosed;
    }
    closeBanner() {
      this.hasBeenClosed = true;
    }
    upgrade() {
      if (this.subscriptions.isMobileSubscription) {
        this.subscriptions.openMobileRedirectModal();
        return;
      }
      if (this.seamlessCheckoutManager.canSeamlessCheckout) {
        this.segment.track('multi-bttp-upgrade');
        this.seamlessCheckoutManager.upgrade({
          feature: 'multiBttp',
          location: 'calendar'
        });
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bttp", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "seamlessCheckoutManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "hasBeenClosed", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "closeBanner", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeBanner"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "upgrade", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "upgrade"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MultipleBttpUpgradeBannerComponent);
});